import React, { useEffect } from "react";
import FullPageLoader from "../components/FullPageLoader";
import CornerDryRose from "../images/corner/corner-dry-rose-art.webp";

const WinePlaylists = ({ playlists }) => {
  useEffect(() => {
    document.title = "Auburn Road - Wine Playlists";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  if (!playlists) {
    return <FullPageLoader />;
  }

  const entries = Object.entries(playlists).filter(([, embed]) => embed);

  return (
    <>
      <img className="corner-dry-rose" src={CornerDryRose} alt="" />
      <div className="container content-page p-t-100">
        <section className="content-hero">
          <p className="content-hero__kicker">Soundtrack for the pour</p>
          <h1 className="huge-text-no-quote content-hero__title">
            Wine Playlists
          </h1>
          <p className="content-hero__intro">
            Music paired with each wine. Press play and pour.
          </p>
        </section>

        {entries.map(([wineName, embed]) => (
          <div className="content-playlist" key={wineName}>
            <h2>{wineName}</h2>
            <div dangerouslySetInnerHTML={{ __html: embed }} />
          </div>
        ))}
      </div>
    </>
  );
};

export default WinePlaylists;
